import { prefixObjectValues as pre } from '../utils';

const prefix = 'peer-reference-table';

const table = pre(
  {
    container: 'container',
    row: 'row-',
    date: 'date-sort-',
    type: 'type-sort-',
    name: 'name-sort-',
    status: 'status-sort-',
    actions: 'actions-sort-',
    deleteBtn: 'delete-btn-',
    resendBtn: 'resend-btn-',
    addBtn: 'add-btn-',
    download: 'download-btn-',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
};
